module.exports = __webpack_public_path__ + "img/Kugel_Geschenke.242bdfcc.svg";